import { Injectable } from '@angular/core'
import { NativeDateAdapter } from '@angular/material/core'

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override getDateNames(): string[] {
    return [...Array(31).keys()].map((i) => String(i + 1))
  }
}
